import { usePwaInstall } from '../hooks/usePwaInstall'

/**
 * Подсказка «Установить приложение» внизу экрана.
 * Android/Chromium — кнопка с нативным prompt; iOS Safari — текстовая инструкция.
 * Ничего не рендерит, если приложение уже установлено или подсказка закрыта.
 */
export const InstallPrompt = () => {
  const { canInstall, iosHint, promptInstall, dismiss } = usePwaInstall()

  if (!canInstall && !iosHint) return null

  return (
    <div className="pwa-install" role="dialog" aria-label="Установить приложение">
      <div className="pwa-install__body">
        <div className="pwa-install__title">Установить «Провизиум»</div>
        {iosHint ? (
          <div className="pwa-install__text">
            Нажмите{' '}
            <span aria-hidden="true">⎋</span> «Поделиться», затем «На экран „Домой“».
          </div>
        ) : (
          <div className="pwa-install__text">Быстрый доступ с домашнего экрана, без браузера.</div>
        )}
      </div>
      <div className="pwa-install__actions">
        {canInstall && (
          <button type="button" className="pwa-install__btn" onClick={promptInstall}>
            Установить
          </button>
        )}
        <button
          type="button"
          className="pwa-install__close"
          onClick={dismiss}
          aria-label="Закрыть подсказку"
        >
          ✕
        </button>
      </div>
    </div>
  )
}
